import { useUserStore } from '@/stores/user';

export const vPermission = {
  mounted(el: HTMLElement, binding: any) {
    const userStore = useUserStore();
    const { value, arg } = binding;
    
    if (!value) {
      return;
    }
    
    const hasPermission = checkPermission(userStore.userInfo?.permissions || [], value);
    
    if (!hasPermission) {
      switch (arg) {
        case 'hide':
          el.classList.add('permission-hidden');
          break;
        case 'disable':
          (el as HTMLButtonElement).disabled = true;
          el.classList.add('permission-disabled');
          break;
        default:
          el.parentNode?.removeChild(el);
      }
    }
  }
};

export function checkPermission(permissions: any[], requiredPermission: string): boolean {
  // 遍历权限树
  for (const permission of permissions) {
    // 检查当前权限
    if (permission.name === requiredPermission) {
      return true;
    }
    
    // 检查子权限
    if (permission.children && permission.children.length > 0) {
      if (checkPermission(permission.children, requiredPermission)) {
        return true;
      }
    }
  }
  
  return false;
}

// 暂未使用 后续可能需要使用

// 判断是否具有所有权限
export function hasAllPermissions(permissions: any[], requiredPermissions: string[]): boolean {
  return requiredPermissions.every(permission => checkPermission(permissions, permission));
}

// 判断是否具有任意一个权限
export function hasAnyPermission(permissions: any[], requiredPermissions: string[]): boolean {
  return requiredPermissions.some(permission => checkPermission(permissions, permission));
}